import React from "react";
import { baseUrl } from "env";
import { connect } from "react-redux";
class Slide extends React.Component {
  render = () => (
    <div
      className={`${
        this.props.screen.mq === "l" || this.props.screen.mq === "m" ? "" : "s"
      } slide `}
      style={{
        backgroundImage: `url(${baseUrl}/api/media/media/${this.props.item.media_id})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "50% 60%"
      }}
    >
      <div className="orange_layer" />
      <div className="contenct_holder">
        <p className="slide_title">{this.props.item.title}</p>
        <p className="slide_sub_title">{this.props.item.description}</p>
        <p className="slide_description">
          {this.props.item.content[0] ? this.props.item.content[0].value : ""}
        </p>
        {this.props.item.url ? (
          <a target="_blank" href={this.props.item.url}>
            <button>Detaylı Bilgi</button>{" "}
          </a>
        ) : null}
      </div>
    </div>
  );
}
const mapStateToProps = state => ({
  screen: state.screen
});
export default connect(mapStateToProps)(Slide);
